import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_PAYFREQUENCY);


const state = {
  data: [],
  isFetching: false,
  isSaving: false,
  isDeleting: false,
};



const mutations = {
  set: (state, [payload]) => {
      state.data = payload;
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
  setEditMode: (state, payload) => {
    //console.log("payload---" , payload.record);

    //  //console.log("record---" + record);
    state.editMode = payload.editMode;
    state.record = payload.record;
  }
}

const actions = {
  async fetchAll({commit}) {
      //console.log("[state/onboard/payFrequency/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`);
      commit("setFetching", false);
      //console.log("[state/onboard/payFrequency/fetchAll] res: ", res);
      if(res.status == 200) {
        if(res.data.payload.data.length!=0)
         commit("set", [res.data.payload.data]);
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions,
}
